import React from 'react'
import SchoolListAddNewSchoolPageContainer from '../../../container/stateContainer/SchoolListAddNewSchoolPageContainer'

const SchoolListAddNewSchoolPage = () => {
  return (
    <div>
     <SchoolListAddNewSchoolPageContainer/>
    </div>
  )
}

export default SchoolListAddNewSchoolPage
